import React, {useEffect} from 'react'
import {useTranslation} from "react-i18next";
import {Box, Grid, Typography} from "@mui/material";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {getCurrentLanguage} from "../../utils/Helpers";


const InfoPageSkyViewFactorLayout = () =>{

    const {t,i18n} = useTranslation()
    let key = getCurrentLanguage(i18n);
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/sky-view-factor",
            type:"pageView"
        }))
    }, []);
    return (
        <div>
            <Typography style={{textAlign:"center"}}  variant="h3" gutterBottom>
                {t('info_page.sky_view_factor.title' as any)}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {t('info_page.sky_view_factor.subtitle' as any)}
            </Typography>
            <Grid container xs={12} justifyContent="center">
                        <Box
                            component="img"
                            alt="Soil Type 1"
                            src={require("../../assets/pages/info/"+key+"/svf.png")}
                        />
            </Grid>
            <Typography paragraph>
                SVF=0: {t('info_page.sky_view_factor.svf_0' as any)}
                <br/>
                SVF=1: {t('info_page.sky_view_factor.svf_1' as any)}
            </Typography>
            <br/>
            <Grid container xs={12}>
                <Grid item xs={2}>
                    <Typography variant="h3">
                        SVF: 1
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Box
                        component="img"
                        src={require("../../assets/pages/info/common/pfeil.png")}
                    />
                </Grid>

                <Grid item xs={2}>
                    <Typography variant="h3">
                        SVF: 0
                    </Typography>
                </Grid>
            </Grid>
            <br/>
            <Typography variant="h6">
                {t('info_page.sky_view_factor.subtitle2' as any)}:
            </Typography>
            <br/>
            <Grid container xs={12}>
                <Grid item xs={4}>
                    <Typography paragraph>
                        {t('info_page.sky_view_factor.title' as any)}: <b>{t('general.high' as any)}</b> | SVF: <b>0,75</b>
                    </Typography>
                    <Box
                        component="img"
                        src={require("../../assets/pages/info/common/svf-hoch.png")}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Typography paragraph>
                        Horizontüberhöhung: <b>{t('general.middle' as any)}</b> | SVF: <b>0,5</b>
                    </Typography>
                    <Box
                        component="img"
                        src={require("../../assets/pages/info/common/svf-mittel.png")}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Typography paragraph>
                        Horizontüberhöhung: <b>{t('general.low' as any)}</b> | SVF: <b>0,17</b>
                    </Typography>
                    <Box
                        component="img"
                        src={require("../../assets/pages/info/common/svf-niedrig.png")}
                    />
                </Grid>
            </Grid>

        </div>
    )
}
export default InfoPageSkyViewFactorLayout
